// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__FoBK5","modalBody":"MealsPop_modalBody__5kZUq"};